// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.patient.file.ParseExternalPatientDataFileRequest */
/* istanbul ignore next */
@GandalfModel
export class ParseExternalPatientDataFileRequest extends GandalfModelBase {

	@GandalfLabel('CDA validation')
	@GandalfValidator({ notNull: { message: 'CDA validation is required' } })
	@GandalfProperty({ designType: Boolean, isRequired: true })
	isCdaValidation!: boolean;

	@GandalfLabel('Patient file')
	@GandalfValidator({ notNull: { message: 'Patient file is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	patientFileId!: number;

}
